module.exports = __webpack_public_path__ + "static/img/middle-zh.37b3fd2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/common/middle-zh.png
// module id = H0JT
// module chunks = 9